import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=34f7b2cc"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34f7b2cc')) {
      api.createRecord('34f7b2cc', component.options)
    } else {
      api.reload('34f7b2cc', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=34f7b2cc", function () {
      api.rerender('34f7b2cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/covenant/edit.vue"
export default component.exports